import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './ScrollIndicator.css';

const ScrollIndicator = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;

      // Cache la flèche si on est à moins de 50px de la fin
      if (windowHeight + scrollTop >= documentHeight - 50) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Vérification immédiate

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // On utilise createPortal pour sortir l'élément du DOM de l'App
  // Cela garantit que position: fixed fonctionne par rapport à la fenêtre
  return ReactDOM.createPortal(
    <div className={`scroll-indicator ${!isVisible ? 'hidden' : ''}`}>
      <div className="keyboard-key">
        <span className="arrow-down">↓</span>
      </div>
      <p className="scroll-text">{t('scrollDown')}</p>
    </div>,
    document.body
  );
};

export default ScrollIndicator;
